export default __webpack_public_path__ + "static/media/saas1.87c0ce45.svg";